<template>
    <div v-if="mode === 'group' && entitiesLoaded"
        :class="{
            'w-chat__widget chat-group': true,
            'minimize': widget,
            'preview-chat': previewMode === 'chat-preview'
        }"><!--add minimize class for small chat-->
        <div class="conversation-screen">
            <vue-custom-scrollbar
                :swicher="activeScrollSidebar"
                id="conversation-group-scroll"
                class="conversation user-modal group"
                :settings="scrollBarSettings"
                :class="{'disable-scroll': !activeScrollSidebar}"
                :style="{'position': disableScroll ? 'static' : 'relative'}"
            >
                <div class="header">

                    <div class="info group" v-if="event.type == 'bang'"
                        :class="{'online': info.event.isOnline, 'was-online': info.event.wasRecentlyOnline && !info.event.isOnline}"
                        @click="openEvent(event.id, 'bang')">
                        <div class="img" :style="{'background': `url(${info.photo_small}) no-repeat center / cover`}"></div>
                        <div class="col">
                            <div class="event-title">{{ event.title }}</div>
                            <div class="date">{{ info.event.date | formatDate('day-date') }}</div>
                        </div>
                    </div>
                    <div class="info group" v-else-if="event.type == 'club'"
                        @click="openClub(event.id, 'club')">
                        <div class="img" :style="{'background': `url(${info.photo_small}) no-repeat center / cover`}"></div>
                        <div class="col">
                            <div class="event-title">{{ event.title }}</div>
                        </div>
                    </div>

                    <div class="controls">
                      <div v-if="previewMode === 'chat-preview'" class="hide-button" @click="hideChat('bang', event.id, false); clearHiddenChat(event.id)">
                        <i class="hide-button--icon"></i>
                      </div>
                      <i class="trash" v-if="event.type !== 'bang'" @click="leaveClub(event); finishConversation();"></i>
                      <i class="back" @click="finishConversation(); clearHiddenChat(event.id)"></i>
                    </div>

                </div>
                <GroupChatComponent
                    :chatMode="chatMode"
                    :conversation_id="conversation_id"
                    :eventId="event.id"
                    @changeScrollBarState="changeScrollBarState"
                    @changeScrollStyle="changeScrollStyle"
                >
                </GroupChatComponent>

                <MediaWatcher ref="mediaWatcherClipBoardPhotoGroup" :items="[{id:1,'photo_orig' : clipboardFileUrl}]" type="photo" :fullscreen="true"></MediaWatcher>
                <GroupChatPhotosReveals></GroupChatPhotosReveals>
                <GroupChatVideosReveals></GroupChatVideosReveals>
            </vue-custom-scrollbar>
        </div>
    </div>
</template>

<script>
    import GroupChatComponent from '@chat/views/widgets/GroupChatComponent.vue';
    import GroupChatPhotosReveals from '@chat/views/widgets/GroupChatPhotosReveals.vue';
    import GroupChatVideosReveals from '@chat/views/widgets/GroupChatVideosReveals.vue';
    import {mapState} from 'vuex';
    import chatModule from "../../module/store/type";

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import MediaWatcher from "../../../buddy/views/widgets/MediaWatcher.vue";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-chat').default,
            require('@general/lib/mixin-events').default,
            require('@general/lib/mixin-clubs').default,
            require('@general/lib/mixin-club-edit').default,
        ],
        components: {
          MediaWatcher,
            GroupChatComponent,
            GroupChatPhotosReveals,
            GroupChatVideosReveals,
            vueCustomScrollbar
        },
        data() {
            return {
                activeScrollSidebar: true,
                chatMode: 'group',
                disableScroll: true,
                scrollBarSettings: {
                    suppressScrollY: false,
                    suppressScrollX: true
                },
                clipboardFileUrl: false
            }
        },
        computed: {
            entitiesLoaded(){
                return !!this.event
            },
            info: function(){
                return {
                    photo_small: this.event.photo_small || null,
                    title: this.event.title || null,
                    user: this.event.user || null,
                    event: this.event || null
                }
            },
            ...mapState({
                mode: state => state.chatModule.modal.mode,
                previewMode: state => state.chatModule.modal.previewMode,
                event: state => state.chatModule.modal.event || null,
                conversation_id: state => state.chatModule.modal.conversation_id || null,
                minimized: state => state.chatModule.modal.minimized,
                widget: state => state.chatModule.modal.widget,
                user: state => state.chatModule.modal.user || null,
                blockedUsersIds: state => state.blockedUsersIds,
            })
        },
        watch: {
            blockedUsersIds: function(blockedUsersIds) {
                if (blockedUsersIds.includes(this.event?.user_id)) {
                    this.finishConversation()
                }
            }
        },
        methods: {
            clearHiddenChat(eventId) {
                let allConv = this.$store.getters[chatModule.getters.conversations.all];

                let index = _.findIndex(allConv, function (conv) {
                  return conv.chatType === 'group' && conv.event.id === eventId;
                })

                let currentConv = allConv[index];
                if(currentConv){
                  currentConv.active = false;

                  this.$set(allConv, index, currentConv);
                }
            },
            changeScrollBarState(value) {
                this.activeScrollSidebar = value;
            },
            changeScrollStyle(activeScrollSidebar, disableScroll) {
                this.activeScrollSidebar = activeScrollSidebar;
                this.disableScroll = disableScroll;
            },
            leaveClub(club){
              if(club.membership == 'host'){
                this.removeClub(club.id)
              }else{
                this.club = club;
                this.updateMembership({ clubId: club.id })
              }
            },
            scrollToBottom() {
                if (app.isMobile) {
                    const scrollElement = this.$el.querySelector('#js-chat-group-cmp').lastElementChild;
                    this.$nextTick(() => {
                        scrollElement.scrollIntoView({block: "center"})
                    });
                } else {
                    const containerName = this.chatMode.toLowerCase();
                    const scrollDiv = document.getElementById('conversation-group-scroll');

                    const lastMessageElem = this.$el.querySelector('#js-chat-group-cmp').lastElementChild;
                    const coordinates = scrollDiv.scrollHeight - lastMessageElem.offsetHeight;

                    this.$nextTick(() => {
                        scrollDiv.scroll({
                            top: coordinates,
                        })
                    })
                }
            },
            chatProfileClick() {
                if (this.minimized) {
                    this.maximizeChat()
                } else {
                    this.event.type == 'bang'
                        ? this.openEvent(this.event.id, this.event.type)
                        : this.openClub(this.event.id, this.event.type)
                }
            }
        },
        mounted(){
            /*console.log('[ModalChatEventDesktopComponent] mounted', {
                event: this.event
            })*/

          let self = this;
          app.$on('show-clipboard-photo-group', function(fileUrl){
            self.clipboardFileUrl = fileUrl;
            self.$refs.mediaWatcherClipBoardPhotoGroup.show(1);
          });
        },
        beforeDestroy() {
            app.$off('show-clipboard-photo-group');
        },
    }
</script>